import React, { useEffect } from "react"

import SEO from "../components/seo"
import "../styles/style.scss"
import "../styles/pages/not-found.scss"

const NotFoundPage = () => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('dots')
    }
  }, [])

  return (
    <main className="not-found-page">
      <SEO title="Page Not Found" noIndex />
      <div className="grid-section">
        <p className="not-found-page__code">404</p>
        <h1 className="not-found-page__title">We can't reach this page</h1>
        <p className="not-found-page__subtitle">
          The link may be broken or the page may have moved.
        </p>
      </div>
    </main>
  )
}

export default NotFoundPage
